import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './error/page-not-found/page-not-found.component';

/**
 * ********************* NOTE *********************
 * Any modifications to the route paths should be reflected in the common/models/app-config.interface.ts
 * file as well. This is crucial for tracking the user's correct page navigation using Google Analytics.
 * *************************************************
 */
const routes: Routes = [
    {
        path: 'home',
        loadChildren: () =>
            import('./home-page/home-page.module').then((m) => m.HomePageModule)
    },
    {
        path: 'shopper-details',
        loadChildren: () =>
            import('./shopper-details/shopper-details.module').then(
                (m) => m.ShopperDetailsModule
            )
    },
    {
        path: 'fetch-shopper-details/:partnerCode/:proxyType/:proxyValue',
        children: [
            {
                path: ':routePathId',
                loadChildren: () =>
                    import('./shopper-details/shopper-details.module').then(
                        (m) => m.ShopperDetailsModule
                    )
            },
            {
                path: 'transaction/:transactionId',
                loadChildren: () =>
                    import('./shopper-details/shopper-details.module').then(
                        (m) => m.ShopperDetailsModule
                    )
            },
            {
                path: 'transaction/:transactionId/:transactionDate',
                loadChildren: () =>
                    import('./shopper-details/shopper-details.module').then(
                        (m) => m.ShopperDetailsModule
                    )
            }
        ]
    },
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    { path: '**', component: PageNotFoundComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    declarations: []
})
export class AppRoutingModule {}
